import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Layout from '../containers/Layout';
import SignInLayout from '../containers/SignInLayout';
import Loadable from '../components/Loadable';
import TestPage from 'pages/TestPage';
import history from './history';
import ClientTest from 'pages/Client';
import Reports from 'pages/dashboards/reports/Reports';
import BookingCom from 'pages/booking.com/BookingCom';

const SignIn = Loadable(lazy(() => import('../pages/SignIn')));
const ResetPassword = Loadable(lazy(() => import('../pages/ResetPassword')));
const Rooms = Loadable(lazy(() => import('../pages/my-hotel/Rooms')));
const AddRoom = Loadable(lazy(() => import('../pages/my-hotel/AddRoom')));
const Orders = Loadable(lazy(() => import('../pages/Orders')));
const Users = Loadable(lazy(() => import('../pages/Users')));
const Billing = Loadable(lazy(() => import('../pages/Billing')));
const Hotels = Loadable(lazy(() => import('../pages/Hotels')));
const General = Loadable(lazy(() => import('../pages/my-hotel/General')));
const AddRate = Loadable(lazy(() => import('../pages/my-hotel/AddRate')));
const AddDiscountRate = Loadable(lazy(() => import('../pages/my-hotel/AddDiscountRate')));
const Rates = Loadable(lazy(() => import('../pages/my-hotel/Rates')));
const HotelUsers = Loadable(lazy(() => import('../pages/my-hotel/HotelUsers')));
const SettingLang = Loadable(lazy(() => import('../pages/settings/Settings')));
const Keys = Loadable(lazy(() => import('../pages/settings/Keys')));
const Promocodes = Loadable(lazy(() => import('../pages/Promocodes')));
const Services = Loadable(lazy(() => import('../pages/Services')));
const Prices = Loadable(lazy(() => import('../pages/prices')));
const Easyms = Loadable(lazy(() => import('../pages/integration/Еаsyms')));
const MonoBank = Loadable(lazy(() => import('../pages/integration/MonoBank')));
const Integration = Loadable(lazy(() => import('../pages/integration/Integration')));
const Design = Loadable(lazy(() => import('../pages/settings/Design.js')));
const Dashboard = Loadable(lazy(() => import('../pages/Dashboard.js')));
const TimeLineDashboard = Loadable(lazy(() => import('../pages/TimeLine.js')));
const AdminPanel = Loadable(lazy(() => import('../pages/settings/Admin.js')));
const InProgress = Loadable(lazy(() => import('../pages/InProgress.js')));
const OrderDetail = Loadable(lazy(() => import('../pages/OrderDetail')));

const routes = [
    {
        element: <SignInLayout />,
        children: [
            {
                path: '/sign-in',
                element: <SignIn />,
            },
            {
                path: '/test',
                element: <TestPage />,
            },
            {
                path: '/reset-password',
                element: <ResetPassword />,
            },
        ],
    },

    {
        element: <Layout />,
        children: [
            {
                path: '/',
                element: <Navigate to="/dashboard" />,
            },
            {
                path: '/rooms/edit/:roomId',
                element: <AddRoom />,
            },
            {
                path: '/rooms/add',
                element: <AddRoom />,
            },
            {
                path: '/rates',
                element: <Rates />,
            },
            {
                path: '/rates/add',
                element: <AddRate history={history} />,
            },
            {
                path: '/rates/add/:rateId',
                element: <AddDiscountRate history={history} />,
            },
            {
                path: '/rates/edit/:id/:rateId',
                element: <AddDiscountRate history={history} />,
            },
            {
                path: '/rates/edit/:id',
                element: <AddRate />,
            },
            {
                path: '/general-information',
                element: <General />,
            },
            {
                path: '/hotel-users',
                element: <HotelUsers />,
            },
            {
                path: '/rooms/add',
                element: <AddRoom />,
            },
            {
                path: '/orders',
                element: <Orders />,
            },
            {
                path: '/orders/:id',
                element: <OrderDetail />,
            },
            {
                path: '/employee',
                element: <Users />,
            },
            {
                path: '/hotels',
                element: <Hotels />,
            },
            {
                path: '/billing',
                element: <Billing />,
            },
            {
                path: '/integration',
                children: [
                    {
                        index: true,
                        element: <Integration />,
                    },
                    {
                        path: 'easyms',
                        element: <Easyms />,
                    },
                    {
                        path: 'monobank',
                        element: <MonoBank />,
                    },
                ],
            },
            {
                path: '/booking-com',
                element: <BookingCom />,
            },
            {
                path: '/rooms',
                element: <Rooms />,
            },
            {
                path: '/client',
                element: <ClientTest />,
            },
            {
                path: '/settings',
                element: <SettingLang />,
            },
            {
                path: '/keys',
                element: <Keys />,
            },
            {
                path: '/promo-codes',
                element: <Promocodes />,
            },
            {
                path: '/services',
                element: <Services />,
            },
            {
                path: '/prices',
                element: <Prices />,
            },
            {
                path: '/design',
                element: <Design />,
            },
            {
                path: '/dashboard',
                element: <Dashboard />,
            },
            {
                path: '/reports',
                element: <Reports />,
            },
            {
                path: '/timeline',
                element: <TimeLineDashboard />,
            },
            {
                path: '/url',
                element: <AdminPanel />,
            },
            {
                path: '/income-report',
                element: <InProgress />,
            },
            {
                path: '/services-report',
                element: <InProgress />,
            },
        ],
    },
    {
        path: '*',
        element: <Navigate to="/" />,
    },
];

export default function MainRoutes() {
    return useRoutes(routes, '');
}
